function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledStoriesSlickCarouselComponent } from "./stories-slick-carousel-component.scss";
import Slider from "react-slick";
import classnames from "classnames";
class StoriesSlickCarouselComponent extends PureComponent {
    /**
   * Add event listener
   */ componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    }
    /**
   * Remove event listener
   */ componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }
    /**
   * Calculate & Update state of new dimensions
   */ updateDimensions() {
        this.setState({
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    }
    renderItems() {
        const { items, renderItem } = this.props;
        return items.map((item, index)=>/*#__PURE__*/ _jsx("div", {
                className: "carousel-item",
                children: renderItem(item, index)
            }, index));
    }
    renderItemsWithCarousel(settings) {
        return /*#__PURE__*/ _jsx(Slider, _object_spread_props(_object_spread({}, settings), {
            ref: settings.onCarouselMounted,
            children: this.renderItems()
        }));
    }
    // showing on mobile
    renderItemsWithoutCarousel(items, renderItem) {
        return /*#__PURE__*/ _jsx("div", {
            className: "items-without-carousel",
            children: items.map((item, index)=>renderItem(item, index))
        });
    }
    render() {
        const _this_props = this.props, { items, renderItem, minWidthForCarousel } = _this_props, settings = _object_without_properties(_this_props, [
            "items",
            "renderItem",
            "minWidthForCarousel"
        ]);
        const { windowWidth } = this.state;
        const showCarousel = !windowWidth || windowWidth > minWidthForCarousel;
        return /*#__PURE__*/ _jsxs(StyledStoriesSlickCarouselComponent, {
            className: classnames("stories-slick-carousel"),
            children: [
                showCarousel && this.renderItemsWithCarousel(settings),
                !showCarousel && this.renderItemsWithoutCarousel(items, renderItem)
            ]
        });
    }
    constructor(props){
        super(props);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.state = {
            windowWidth: 0,
            windowHeight: 0
        };
    }
}
export { StoriesSlickCarouselComponent as default };
StoriesSlickCarouselComponent.defaultProps = {
    dots: true,
    infinite: true,
    fade: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 8000,
    minWidthForCarousel: -1 // if width smaller than that - don't render carousel
};
